// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Summary_buttonsContainer__wtTwf","disclaimerContainer":"Summary_disclaimerContainer__vYCQt","skeletonLoadingAnimation":"Summary_skeletonLoadingAnimation__rHtEZ"};